import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initI18n } from './i18n';
import { flushPractice } from './lib/practice';
import { isAndroidApp } from './lib/platform';
import { registerServiceWorker } from './lib/pwa';
import { applyMotion } from './lib/settings';
import { restoreCosmetics } from './lib/cosmetics';
import { APP_NAME } from './brand';
import './styles.css';

document.title = APP_NAME;
initI18n();
applyMotion();
// Read the Android app signals before any in-app navigation drops them.
isAndroidApp();
restoreCosmetics();
registerServiceWorker();
// Local practice rounds finished offline are sent when the app starts again.
void flushPractice();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
